<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("wms.menu.product") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                    <base-button
                        size="md"
                        type="neutral"
                        @click="handleCreate()"
                        >{{ $t("new") }}</base-button
                    >

                    <!-- <base-button size="md" type="neutral" v-if="isCorporateAdmin || isDtacAdmin">{{
            $t("upload_file")
          }}</base-button> -->
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
                        <div class="row">
                            <div class="col-lg-3">
                                <base-input
                                    v-model="searchQuery"
                                    prepend-icon="fas fa-search"
                                    :placeholder="$t('search')"
                                >
                                </base-input>
                            </div>
                        </div>
                    </template>
                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >
                            <el-table-column :label="$t('name')">
                                <div slot-scope="{ row }">
                                    {{ row.name }}
                                </div>
                            </el-table-column>

                            <el-table-column
                                align="right"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <base-button
                                        @click.native="
                                            handleDetail($index, row)
                                        "
                                        class="edit"
                                        type="warning"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-list"></i>
                                    </base-button>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link text-white"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <div class="row">
                    <div class="col-md-10">
                        <base-input :label="$t('name')" v-model="skurandom.name">
                        </base-input>
                    </div>
                </div>

				<hr/>

                <div class="row">
                    <div class="col-md-10">
                        <base-input v-if="isCreateMode" >
                            <el-select
                                v-model="wms_product_id"
                                :placeholder="$t('product')"
                                :label="$t('product')"
                                filterable
                            >
                                <el-option
                                    v-for="option in WmsProductTable"
                                    :key="option.ID"
                                    :label="option.Name"
                                    :value="option.ID"
                                />
                            </el-select>
                        </base-input>
                    </div>

                    <div class="col-md-2">
                        <base-button size="md" type="primary" @click="addItem()" v-if="isCreateMode"
                            >Add</base-button
                        >
                    </div>
                </div>

                <!-- show Items -->
                <div
                    class="row py-2"
                    v-for="(option, index) in skurandom.products"
                    :key="index"
                >
                    <div class="col-md-10">
                        {{ option.name }}
                    </div>
                    <div class="col-md-2">
                        <base-button
                            size="md"
							class="btn-sm"
                            @click="removeItems( index)"
                            type="danger"
							v-if="isCreateMode"
                        >
                            <i class="fa fa-trash"></i
                        ></base-button>
                    </div>
                </div>
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                    disabled
					v-if="!isSkuRandomValid && isCreateMode"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
					v-if="isSkuRandomValid && isCreateMode"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { read, utils, writeFile } from "xlsx";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    computed: {
        ...mapGetters({
            tableDataOrg: "Product/getDataSkuRandom",
            getCurrentPage: "Product/getCurrentPage",
            WmsProductTable: "WmsProduct/getData"
        }),
        tableData: function() {
            if (this.productStatus != 0) {
                return this.tableDataOrg.filter(m => {
                    return m.status == this.productStatus;
                });
            }

            return this.tableDataOrg;
        },
        searchParams: function() {
            return {
                platform_id: 1
            };
        },
        isSkuRandomValid: function() {

			// if name duplicate return false
            return this.skurandom.name != "" && this.skurandom.products.length > 0;
        }, 
		isSkuRandomNameDuplicate: function() {
			return this.tableDataOrg.filter(v => {
				return v.name == this.skurandom.name;
			}).length > 0;
		}

    },
    data() {
        return {
            propsToSearch: ["name"],
			selectedRows: [],
            showModal: false,
			isCreateMode: false,
            skurandom: {
                name: "",
                products: []
            },
			wms_product_id:""
        };
    },
    mounted() {
        this.listWMS();
        this.listData();
    },
    methods: {
        ...mapActions({
            createData: "Product/createSkuRandom",
            deleteData: "Product/deleteSkuRandom",
            listData: "Product/listSkuRandom",
            setCurrentPage: "Product/setCurrentPage",
            listWMS: "WmsProduct/listData"
        }),

        handleCreate() {
			this.isCreateMode = true
            this.skurandom.name = "";
            this.skurandom.products = [];
            this.showModal = true;
        },
        addItem() {

			// find wms product from table
			let wms_product = this.WmsProductTable.filter(v=>{
				return v.ID == this.wms_product_id
			})

			if (wms_product.length ==0) {
				return 
			}

			console.log("Add Items",wms_product)

			// check id not duplicate in products
			let isDuplicate = this.skurandom.products.filter(v=>{
				return v.id == wms_product[0].ID
			})

			if (isDuplicate.length > 0) {
				console.log("duplicate")
				return
			}


            this.skurandom.products.push({
                name: wms_product[0].Name,
                wms_product_id: wms_product[0].ID
            });
        },
        removeItems( index) {
            this.skurandom.products.splice(index, 1);
        },
        handleUpdate() {
			if (this.isSkuRandomNameDuplicate) {
				// show error duplicate
				swal.fire({
					title: "ชื่อการสุ่มซ้ำกับชื่ออื่น",
					text: ``,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return

			}
            this.showModal = false;
            this.createData(this.skurandom)
                .then(resp => {
                    this.listData(this.searchParams);
                    swal.fire({
                        title: this.$t("create_success"),
                        text: ``,
                        icon: "success",
                        confirmButtonClass: "btn btn-success btn-fill",
                        buttonsStyling: false
                    });
                })
                .catch(err => {
                    swal.fire({
                        title: this.$t(err.response.data.Msg),
                        text: this.getErrorText(err.response.data),
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
                });
        },
		handleDetail(index, row) {
			this.isCreateMode = false
			this.skurandom.name = row.name
			// parse json
			this.skurandom.products =	JSON.parse(row.lists)
			this.showModal = true

		},
        handleDelete(index, row) {
            this.setCurrentPage(this.pagination.currentPage);
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
                            this.pagination.currentPage = this.getCurrentPage;
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
        GetProductUrl(filename) {
            return (
                process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
            );
        }
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
